import { store } from 'apps/company/store';
import { show, hide } from 'reducers/loadingReducer';
const Loading = {
  openLoading: (delay, duration) => {
    setTimeout(() => store.dispatch(show(true)), delay || 0);
    if (duration) {
      setTimeout(() => store.dispatch(hide()), 300);
    }
    return;
  },
  closeLoading: (delay) => {
    setTimeout(() => {
      store.dispatch(hide())
    }, delay || 300);
    return;
  }
}

export default Loading;